import { frontendActions, OPEN_BLANK_URL_TARGET } from '@cmctechnology/webinvest-store-frontend';
import { Direction, ORDER_TICKET_WINDOW_HEIGHT, ORDER_TICKET_WINDOW_WIDTH, TradeType, tradeTypeToPath } from './constants';

export const openQuickOrderTicket = (direction: Direction, tradingRoutePrefix: string, tradeType: TradeType = TradeType.SHARE, stockCode?: string) => {
  let url = `${tradingRoutePrefix}/${tradeTypeToPath[tradeType]}/QuickTicket?sd=${direction}`;
  if (stockCode) {
    url += `&sc=${stockCode}`;
  }
  const left = (window.screen.width / 2 - ORDER_TICKET_WINDOW_WIDTH / 2).toFixed(0);
  const top = (window.screen.height / 2 - ORDER_TICKET_WINDOW_HEIGHT / 2).toFixed(0);
  const pars = `height=${ORDER_TICKET_WINDOW_HEIGHT},width=${ORDER_TICKET_WINDOW_WIDTH},left=${left},top=${top},resizable=1,status=1,scrollbars=1,toolbar=0,location=0,directories=0,menubar=0`;
  frontendActions.redirectToUrl(url, OPEN_BLANK_URL_TARGET, pars);
};

export const openBulkOrders = (tradingRoutePrefix: string) => {
  const url = `${tradingRoutePrefix}/Trade/BulkOrders`;
  frontendActions.redirectToUrl(url, OPEN_BLANK_URL_TARGET);
};
